import styled from "styled-components"

interface PerformanceTestStatusBadgeProps {
  status: string
  className?: string
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void
}

const StyledBadge = styled.span<{ status: string; clickable?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  border: 1px solid #e2e8f0;
  text-transform: capitalize;
  position: relative;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
    background: ${({ status }) => {
      switch (status) {
        case "passed":
          return "#22c55e"
        case "issue":
          return "#ef4444"
        case "scheduled":
          return "#43e0f8"
        case "rescheduled":
          return "#3b82f6"
        case "running":
          return "#e3930a"
        default:
          return "#94a3b8"
      }
    }};
  }

  color: ${({ status }) => {
    switch (status) {
      case "passed":
        return "#15803d"
      case "issue":
        return "#b91c1c"
      case "scheduled":
        return "#2db2c8"
      case "rescheduled":
        return "#2563eb"
      case "running":
        return "#f59e0b"
      default:
        return "#64748b"
    }
  }};

  ${({ clickable }) =>
    clickable &&
    `
    cursor: pointer;
  `}
`

export const PerformanceTestStatusBadge = ({ status, className, onClick }: PerformanceTestStatusBadgeProps) => {
  const isClickable = ["passed", "issue"].includes(status.toLowerCase())

  return (
    <StyledBadge status={status.toLowerCase()} clickable={isClickable} className={className} onClick={onClick}>
      {status}
    </StyledBadge>
  )
}
